module.exports = __webpack_public_path__ + "static/media/Mock-pasos.0bfd3da8.webp";